import React from 'react';
import { ThemeProvider } from 'styled-components';
import { LinkContext } from '../Link/LinkContext.js';
import { resolveLanguage, LocaleContext } from '../Locale/LocaleContext.js';
import { getValidLangOrFallback } from '../Locale/utils.js';
import { SDS } from '../common/namespace.js';

const BrandWrapper = (props) => {
    const { children, config, lang: propLang, theme } = props;
    const namespacedTheme = { [SDS]: theme };
    const lang = propLang
        ? // `lang` property is given to BrandWrapper component, LocaleContext
            // will be initialized using this value, if it is valid.
            propLang
        : // `lang` property is undefined. try to resolve a language from
            // the document or browser preferences.
            resolveLanguage();
    return (React.createElement(ThemeProvider, { theme: namespacedTheme },
        React.createElement(LocaleContext.Provider, { value: { lang: getValidLangOrFallback(lang) } },
            React.createElement(LinkContext.Provider, { value: {
                    visitedStyle: typeof (config === null || config === void 0 ? void 0 : config.Link.visited) === 'boolean' &&
                        (config === null || config === void 0 ? void 0 : config.Link.visited),
                } }, children))));
};

export { BrandWrapper };
//# sourceMappingURL=BrandWrapper.js.map
